import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { PLANS_PATH, type Gate } from './index'

/**
 * The upsell call to action. Billing does not exist and the Owner has not ruled on
 * where "Upgrade" leads (next-cycle-overview open question 9), so it opens the in-app
 * Plans page (current plan, what it includes, usage, how to change it): no prices.
 */
export function UpsellLink({ children = 'See plans' }: { children?: ReactNode }) {
  return (
    <Link to={PLANS_PATH} className="upsell-link">
      {children}
    </Link>
  )
}

/** The remedy note shown next to a disabled plan-gated control. */
export function PlanNote({ gate, children, id }: { gate: Gate; children?: ReactNode; id?: string }) {
  // While the plan is still loading the control is simply disabled; no note flickers in.
  if (gate.allowed || gate.loading) return null
  return (
    <p className="form-notice" role="note" id={id}>
      {children}
      {children ? ' ' : ''}
      {gate.reason}
      {gate.upsell && (
        <>
          {' '}
          <UpsellLink />
        </>
      )}
    </p>
  )
}
